// Firebase App (the core Firebase SDK) is always required and must be listed first
import { fbAuth } from "../config/firebase";
import {
  AUTH_WATCH,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAIL,
  AUTH_LOGOUT
} from "./types";

export const authWatch = () => async dispatch => {
  fbAuth.onAuthStateChanged(user => {
    if (user) {
      dispatch({
        type: AUTH_WATCH,
        payload: user
      });
    } else {
      dispatch({
        type: AUTH_WATCH,
        payload: {}
      });
    }
  });
};

export const authLogin = (email, pw) => dispatch => {
  fbAuth
    .signInWithEmailAndPassword(email, pw)
    .then(user => {
      /**
       * @todo Need to check authorization
       */

      return dispatch({
        type: AUTH_LOGIN_SUCCESS,
        payload: user
      });
    })
    .catch(error => {
      console.log(error);
      dispatch({
        type: AUTH_LOGIN_FAIL,
        payload: error
      });
    });
};

export const authLogout = () => dispatch => {
  fbAuth.signOut().then(() => {
    return dispatch({
      type: AUTH_LOGOUT,
      payload: "logout"
    });
  });
};
